import { useState } from 'react';
import SearchSelect from "@ui-components/SearchSelect";
import { InformationCircleIcon, ExclamationCircleIcon } from "@heroicons/react/24/solid";
import { FormattedMessage } from "react-intl";
import { QuotationEnterpriseSelectorProps } from "./types";
import { validateEmail } from "@utils/validate-email";

export const QuotationEnterpriseSelector = ({
  label,
  value,
  loadOptions,
  onChange,
  isDisabled,
  noOptionsMessage,
  defaultOptions,
  blocked
}: QuotationEnterpriseSelectorProps) => {

  return <div>
    <SearchSelect
      label={label}
      value={value}
      onChange={onChange}
      isDisabled={blocked || isDisabled}
      loadOptions={async (search: string, callback:any) => {
        const userOptions = await loadOptions(search)
        callback(userOptions.length > 0 ? userOptions : [{
          label: search,
          secondaryLabel: search,
          value: null,
          object: null
        }]);
      }}
      defaultOptions={defaultOptions}
      isClearable={!blocked}
      CustomOption={({data: userOption, innerProps, innerRef}: any) => {
        const {object, label, secondaryLabel} = userOption;
        return (
          <article
            ref={innerRef}
            className="py-2 px-3 cursor-pointer hover:bg-blue-50"
            {...innerProps}
          >
            {!!object && <p className="font-semibold text-sm">{label}</p>}
            <p className={!object ? "text-sm" : "text-xs"}>
              {secondaryLabel}
              {!object && (
                <span
                  className="text-xxs text-white uppercase font-semibold rounded bg-am-700 ml-2 px-1 py-0.5">
            <FormattedMessage id="add"/>
          </span>
              )}
            </p>
          </article>
        )
      }}
    />
    <div>
      <div className="text-xs text-gray-400">
        <InformationCircleIcon className="w-3 inline-block mr-1 -mt-0.5"/>
        <FormattedMessage
          id="share_with_external_user_helper"
          defaultMessage={
            "Cerca l'utente con il quale vuoi condividere il preventivo utilizzando il campo di ricerca, " +
            "digitandone il nome o l'indirizzo email. Nel caso in cui non compaia nella lista, potrai " +
            "comunque digitare l'indirizzo email e confermare l'operazione invitando l'utente a registrarsi."
          }
        />
      </div>
      {!!value?.secondaryLabel && !validateEmail(value?.secondaryLabel) && (
        <div className="flex flex-row items-center gap-1.5 text-red-500 text-sm mt-3">
          <ExclamationCircleIcon className="w-5"/>
          <FormattedMessage
            id="invalid_email"
            defaultMessage="L'indirizzo email inserito non è valido"
          />
        </div>
      )}
    </div>
  </div>
}